<div class="iss-drawer-header">
  <div class="iss-drawer-header-title">{{ title }}</div>
  <div class="iss-drawer-header-subtitle" *ngIf="subtitle">{{ subtitle }}</div>
</div>
